import { render, staticRenderFns } from "./PartArea.vue?vue&type=template&id=602fa9e5&scoped=true&"
import script from "./PartArea.vue?vue&type=script&lang=js&"
export * from "./PartArea.vue?vue&type=script&lang=js&"
import style0 from "./PartArea.vue?vue&type=style&index=0&id=602fa9e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602fa9e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VImg,VRow})
